import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readEmailData: id =>
    api
      .send({
        query: gql`
          query READ_ALL($id: ID!) {
            Mail {
              readEmailData(id: $id) {
                # logo de la empresa.
                img

                # options
                emailOptions {
                  cc
                  greeting
                  title
                  body
                  footer
                  calltoaction
                  link
                  imgHeader

                  byeMessage
                  info
                  mainColor
                  estadoCuenta

                  signature {
                    sign
                    name
                    title
                  }

                  template
                }
              }
            }
          }
        `,
        variables: {
          id
        }
      })
      .then(result => result.data.data.Mail.readEmailData),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: EmailDataInput!) {
            Mail {
              create(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Mail.create),

  deleteImg: (_idEmisor, logo) =>
    api
      .send({
        query: gql`
          mutation DELETE($_idEmisor: ID!, $logo: String!) {
            Mail {
              deleteImg(_idEmisor: $_idEmisor, logo: $logo)
            }
          }
        `,
        variables: {
          _idEmisor,
          logo
        }
      })
      .then(result => result.data.data.Mail.deleteImg)
}
